import React, { useContext, useEffect } from "react";
import styles from "./AppMainQ.module.css";
import HomeMenuCard from "./HomeMenuCard/HomeMenuCard";
import sterilizationImage from "../../assets/images/ICONO STERILIZATION NEW.svg";
import washingImage from "../../assets/images/WASHING.svg";
import hygieneMonitoringImage from "../../assets/images/ICONO HYGIENE MONITORING.svg";
import dispatchImage from "../../assets/images/Almacenamiento y despacho.svg";
import receptionImage from "../../assets/images/Recepción de materiales.svg";
import DashboardMain from "../DashboardMain/DashboardMain";
import ButtonQ from "../../components/ButtonQ/ButtonQ";
import AccordionDownloader from "../../components/Downloader/AccordionDownloader";
import LocalizationContext from "../../utils/LocalizationContext";
import { getSession, getUserType } from "../../utils/sessionHandler";
import t from "../../utils/translation";
import Redirect from "../../utils/Redirect";

export default function AppMainQ() {
  const tra = useContext(LocalizationContext);

  const user = getSession();
  function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

  return (
    <div className={styles.homeContainer}>
      <div className={styles.home}>
        {/* <div className={'col-lg-12'} style={{marginBottom: 20}}>
          		<AccordionDownloader translations={translations}></AccordionDownloader>
        	</div> */}
        <p className={styles.title}>{t("WelcomeBack")},</p>
        <p className={`${styles.title} ${styles.username}`}>{`${capitalize(
          user.Name
        )} ${user.LastName.charAt(0)}.`}</p>
        <div className={styles.optionsContainer}>
          <HomeMenuCard
          title={t("BlankEntry217") || "Reception"}
          categoryId={5}
          image={receptionImage}
          url={"/appreceptionmenu"}
        />
          <HomeMenuCard
            title={t("WashingSpan")}
            categoryId={2}
            image={washingImage}
            url={"/appwashingmenu"}
          />
          <HomeMenuCard
            title={t("BlankEntry78") || "Hygiene Monitoring"}
            image={hygieneMonitoringImage}
            url={"/appmanagehygienemonitoring"}
            categoryId={3}
          />
          <HomeMenuCard
            title={t("SterilizationSpan")}
            categoryId={1}
            image={sterilizationImage}
            url={"/appsterilization"}
          />
          <HomeMenuCard
            title={t("BlankEntry100") || "Storage"}
            categoryId={4}
            image={dispatchImage}
            url={"/appdispatchmenu"}
          />
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <ButtonQ
            caption={t("BlankEntry42")}
            onClick={() =>
              Redirect({
                redirect: true,
                path: "/appmaterialtracking",
              })
            }
            color="secondary"
            isVerticalMargined={true}
          />
          {getUserType() !== 2 && (
            <ButtonQ
              caption={t("ProfileSpan") || "Profiles"}
              onClick={() =>
                Redirect({
                  redirect: true,
                  path: "/appprofiles",
                })
              }
              color="secondary"
              isVerticalMargined={true}
            />
          )}
        </div>
        <DashboardMain />
      </div>
    </div>
  );
}
